import React from "react";
import { Loading } from "@drconsulta/library";

export default class LoadingReact extends React.Component {
    render() {
        return (
            <div className='center'>
                <Loading />
            </div>
        );

    }
}
